module.exports = __webpack_public_path__ + "static/00001.905063af.jpg";